<section class="services-area ptb-100">
  <div class="container">
    @for (sectionTitleContent of sectionTitle; track sectionTitleContent) {
      <div class="section-title">
        <h2>{{sectionTitleContent.title}}</h2>
        <p>{{sectionTitleContent.paragraphText}}</p>
      </div>
    }

    <div class="row">
      @for (ServicesBoxContent of singleServicesBoxItem; track ServicesBoxContent) {
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div class="single-services-box-item">
            <div class="icon">
              <img [src]="ServicesBoxContent.icon" [alt]="ServicesBoxContent.title + ' service icon'">
            </div>
            <h3><a routerLink="/{{ServicesBoxContent.link}}">{{ServicesBoxContent.title}}</a></h3>
            <p>{{ServicesBoxContent.paragraphText}}</p>
            <a routerLink="/{{ServicesBoxContent.link}}" class="learn-more-btn"><i class="{{ServicesBoxContent.linkIcon}}"></i>{{ServicesBoxContent.linkText}}</a>
            <div class="shape"><img src="assets/img/services/shape4.png" alt="image"></div>
          </div>
        </div>
      }
    </div>
  </div>
</section>